import React from 'react';

import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from 'react-router-dom';

import { useUserContext } from '@/contexts/user';

import ErrorBoundary from '@/views/base/ErrorBoundary';

export const NotAuthenticatedLayout = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { userIsLogged } = useUserContext();

  const publicUrls = location.pathname.startsWith('/accept-workspace/') || location.pathname.startsWith('/token-expired');

  if (!userIsLogged() || publicUrls) {
    return (
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    );
  }

  const callbackUrl = searchParams.get('callbackUrl') || '/';
  return <Navigate to={callbackUrl} replace />;
};
